import React, { useState } from "react";
import styles from "./Home.module.css";

export const Home = () => {
  const [inputValue, setInputValue] = useState("");

  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const phoneNumber = value.replace(/[^\d]/g, "");

    // Format the number with dashes (XXX-XXX-XXXX)
    if (phoneNumber.length <= 3) return phoneNumber;
    if (phoneNumber.length <= 6)
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(formatPhoneNumber(value));
  };

  const handleSend = () => {};

  return (
    <div className={styles.homeContainer}>
      <div className={styles.greenGlow}></div>
      <div className={styles.dotGrid}></div>
      <div className={styles.content}>
        <h1 className={styles.header}>
          Protect your loved ones from{" "}
          <span className={styles.colored}>online scams</span>
        </h1>
        <p className={styles.description}>
          We send your loved ones practice phishing emails and messages to train
          them to spot and avoid real scams.
        </p>
        <div className={styles.inputContainer}>
          <p>Enter your</p>
          <div className={styles.dropdown}>
            <div className={styles.dropbtn}>
              <input
                type={"tel"}
                placeholder={"Phone Number"}
                value={inputValue}
                onChange={handleInputChange}
                className={styles.input}
              />
            </div>
          </div>

          <p>to receive a scam text</p>
          <button className={styles.sendButton} onClick={handleSend}>
            Send Text
          </button>
        </div>
        <p className={styles.opt}>
          *I agree to receive messages sent via an autodialer from (123)
          456-7890, and this agreement isn’t a condition of purchase. I also
          agree to the{" "}
          <a href="/terms" target="_blank" style={{ color: "white" }}>
            terms of service
          </a>
          . Message frequency varies. Message and data rates may apply.
        </p>
      </div>
    </div>
  );
};
